export const drawerWidth = 260;
export const drawerClosedWidth = 50;
export const addEditDrawerWidth  = 350;

export const actionColumns = [''];
export const sentToMatisColumns = ['strSentToMatis'];
export const quantityColumns = ['strQuantity'];


export const pageSizes = [10, 20, 50,100,500,1000];
export const filteringStateColumnExtensions = [
  { columnName: '', filteringEnabled: false },
];